import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Golf = () => {
  return (
    <SportsLayoutComp name={'Golf'}/>
  )
}

export default Golf